module.exports = __webpack_public_path__ + "img/marcheRight1.054d0108.png";